<div class="elm-logo" [ngClass]="['elm-logo--' + size]" [matTooltip]="(isVerifiedByElm ? 'Enum.LeadStatus.Verified' : 'Enum.LeadStatus.NotVerified') | translate" matTooltipPosition="above">
  <img [src]="isVerifiedByElm ? '../../../../../assets/images/elm-color.svg' : '../../../../../assets/images/elm-gray.svg'" class="elm-logo__image">
</div>
